import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { useLocation } from "react-router-dom";
import moment from "moment";
import { useEffect } from 'react';
import axios from 'axios';
import { useState } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import { withStyles } from '@material-ui/core/styles';
import { useParams } from 'react-router-dom';
import SegmentDetail from './SegmentDetail';
import ContactDetail from './ContactDetail';
import PassengersDetail from './PassengersDetail';



const useStyles = makeStyles((theme) => ({
    paper: {
        height: 140,
        width: 100,
    },
    control: {
        padding: "4%",
        marginBottom: "2%",
    },
    main: {
        paddingTop: '10%', backgroundColor: "rgb(246, 249, 252)", minHeight: "100vh",
        [theme.breakpoints.down("sm")]: {
            paddingTop: '32%',
        },
    }
}));

const Accordion = withStyles({
    root: {
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
    expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
    root: {

    },
    content: {
        '&$expanded': {
            margin: '12px 0',
        },
    },
    expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiAccordionDetails);

export default function FlightBook(props) {
    const [spacing, setSpacing] = React.useState("Return");
    const classes = useStyles();
    const search = useLocation().search;
    const journeyType = new URLSearchParams(search).get('journeyType');
    const departureDate = new URLSearchParams(search).get('departureDate');
    const arrivalDate = new URLSearchParams(search).get('arrivalDate');
    const adults = new URLSearchParams(search).get('adults');
    const flightClass = new URLSearchParams(search).get('flightClass');
    const departureAirport = new URLSearchParams(search).get('departureAirport');
    const arrivalAirport = new URLSearchParams(search).get('arrivalAirport');
    const [flight, setFlight] = useState(null)
    const [meta, setMeta] = useState(null)
    const [loading, setLoading] = useState(false);
    const [sortBy, setSortBy] = useState('total_amount');
    const [stops, setStops] = useState(2);
    const { orderId } = useParams();

    useEffect(() => {
        fetchData()
    }, [])

    const fetchData = async (loadNew) => {
        setLoading(true)
        if (orderId) {
            let queryParam = `/flights/offer?offerId=${orderId}`
            let response = await axios.get(queryParam)
            if (response && response.data && response.data.data && response.data.data.data) {
                let data = response.data.data.data
                setFlight(data)
            }

            setLoading(false)
        }
    }

    const handleSortChange = (e) => {
        setSortBy(e.target.value)
        setMeta(null)
    }

    const handleStopChange = (e) => {
        setStops(e.target.value)
        setMeta(null)
    }

    useEffect(() => {
        fetchData(true)
    }, [sortBy, stops])


    const findDuration = (d1) => {
        return d1.replace('P', '').replace('D', 'd ').replace('T', '').replace('H', 'h ').replace('M', 'm')
    }

    const getDateDifference = (d1, d2) => {
        //d1 > d2
        let a = moment(d1);
        let b = moment(d2);

        let min = a.diff(b, 'minutes')
        let hr = a.diff(b, 'hours')
        return hr + "h " + (min - hr * 60) + "m"
    }



    const handleChange = (event) => {
        setSpacing(Number(event.target.value));
    };

    return (
        <div className={classes.main}>
            <div className="container" >
                <div className="mr-0 pl-0">
                    <Grid container>
                        <Typography style={{ fontSize: "30px", fontWeight: "bold" }}>{'Checkout'}</Typography>
                        <Grid item xs="12">
                            <Paper className={classes.control} elevation={0}>
                                <Grid container spacing={4}>
                                    <Grid item xs="12" sm="10" style={{ textAlign: "left" }}>
                                        <Typography style={{
                                            color: 'black',
                                            background: '#E2E2E8',
                                            padding: '6px',
                                            fontSize: '12px',
                                            fontWeight: '400',
                                            borderRadius: '4px',
                                            marginRight: "15px"
                                        }} component="span">{journeyType}</Typography>
                                        <Typography style={{
                                            color: 'black',
                                            background: '#E2E2E8',
                                            padding: '6px',
                                            fontSize: '12px',
                                            fontWeight: '400',
                                            borderRadius: '4px',
                                            marginRight: "15px"
                                        }} component="span">{moment(departureDate).format('ddd, ll')} {journeyType === 'Return' ? '- ' + moment(arrivalDate).format('ddd, ll') : ''}</Typography>
                                        <Typography style={{
                                            color: 'black',
                                            background: '#E2E2E8',
                                            padding: '6px',
                                            fontSize: '12px',
                                            fontWeight: '400',
                                            borderRadius: '4px',
                                            marginRight: "15px"
                                        }} component="span">{adults} Passenger</Typography>
                                        <Typography style={{
                                            color: 'black',
                                            background: '#E2E2E8',
                                            padding: '6px',
                                            fontSize: '12px',
                                            fontWeight: '400',
                                            borderRadius: '4px'
                                        }} component="span">{flightClass}</Typography>
                                    </Grid>
                                    <Grid item xs="12" sm="2">
                                        <Grid container style={{ textAlign: 'right' }}>
                                            <Grid item xs="12" sm="12">
                                                <Typography style={{ fontSize: "16px" }}>{'Total'}</Typography>
                                            </Grid>
                                            <Grid item xs="12" sm="12">
                                                <Typography style={{ fontSize: "30px" }}>A${flight?.total_amount}</Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs="12" sm="6" style={{ marginTop: '-50px' }}>
                                        <Typography style={{ textAlign: "left", fontWeight: "bold", fontSize: "27px" }}>{departureAirport}
                                            <svg width="24" height="24" viewBox="0 0 24 24" aria-label="sync" class="jsx-3696443798 ff-icon">
                                                <path d="M21.65,7.65l-2.79-2.79C18.54,4.54,18,4.76,18,5.21V7H4C3.45,7,3,7.45,3,8v0c0,0.55,0.45,1,1,1h14v1.79 c0,0.45,0.54,0.67,0.85,0.35l2.79-2.79C21.84,8.16,21.84,7.84,21.65,7.65z"></path>
                                                {journeyType === 'Return' && <path d="M2.35,16.35l2.79,2.79C5.46,19.46,6,19.24,6,18.79V17h14c0.55,0,1-0.45,1-1v0c0-0.55-0.45-1-1-1H6v-1.79 c0-0.45-0.54-0.67-0.85-0.35l-2.79,2.79C2.16,15.84,2.16,16.16,2.35,16.35z"></path>}
                                            </svg> {arrivalAirport}</Typography>
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Grid>
                        <Typography style={{ fontSize: "26px" }}>{'Selected Flight'}</Typography>
                        <Grid item xs="12" >
                            <Paper className={classes.control} elevation={0}><Grid container spacing={4}>
                                <Grid item xs="12" sm="12" style={{ textAlign: "left" }}>
                                    {flight && flight.slices.map((airport) => {
                                        return <>
                                        <Grid container style={{ marginBottom: '20px' }}>
                                            <Grid item sm="1" xs="2">
                                                <img title="Grospick Airways" height="48px" width="48px" src={`https://images.kiwi.com/airlines/64/${airport.segments[0].marketing_carrier.iata_code}.png`} class="jsx-1041521223" />
                                            </Grid>
                                            <Grid item sm="7" xs="10">
                                                <Grid container>
                                                    <Grid item xs="12">
                                                        <Typography style={{ fontWeight: "bold", fontSize: "16px" }}>{moment(airport.segments[0].departing_at).format('LT')} - {moment(airport.segments[airport.segments.length - 1].arriving_at).format('LT')}</Typography>
                                                    </Grid>
                                                    <Grid item xs="12">
                                                        <Typography stle={{ fontSize: "14px" }}>{airport.fare_brand_name ? airport.fare_brand_name : airport.segments[0].passengers[0].cabin_class_marketing_name} · {airport.segments[0].marketing_carrier.name}</Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item sm="2" xs="10">
                                                <Grid container>
                                                    <Grid item xs="12">
                                                        <Typography style={{ fontWeight: "bold", fontSize: "16px" }}>{findDuration(airport.duration)}</Typography>
                                                    </Grid>
                                                    <Grid item xs="12">
                                                        <Typography stle={{ fontSize: "14px" }}>{airport.origin.iata_code} - {airport.destination.iata_code}</Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item sm="2" xs="2">
                                                <Grid container>
                                                    <Grid item xs="12">
                                                        <Typography style={{ fontWeight: "bold", fontSize: "16px" }}>{airport.segments.length === 1 ? 'Direct' : (airport.segments.length - 1) + ' Stop'}</Typography>
                                                    </Grid>
                                                    {airport.segments.length > 1 &&
                                                        airport.segments.map((segment, index) => {
                                                            if (index !== airport.segments.length - 1) {
                                                                return (<Grid item xs="12">
                                                                    <Typography style={{ fontSize: "14px" }}>{getDateDifference(airport.segments[index + 1].departing_at, segment.arriving_at) + ' ' + segment.destination.iata_code}</Typography>
                                                                </Grid>)
                                                            }
                                                        })
                                                    }
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                            <Grid container style={{ marginBottom: '20px' }}>
                                                {airport.segments.map((segment, index) => {
                                                    return <SegmentDetail segment={segment} index={index} segments={airport.segments}/>
                                                })}
                                            </Grid>
                                        </>
                                    })}

                                </Grid>
                            </Grid>
                            </Paper>

                            {loading && <CircularProgress />}
                        </Grid>
                      
                            <ContactDetail />
                  
                            <PassengersDetail />
                        <Typography style={{ fontSize: "26px" }}>{'Payment'}</Typography>
                        <Grid item xs="12">
                            <Paper className={classes.control} elevation={0}>
                                <Grid container spacing={4}>
                                    <Grid item xs="12" sm="6">
                                        Coming Soon
                                    </Grid>
                                    <Grid item xs="12" sm="6">

                                    </Grid>
                                </Grid>
                            </Paper>
                        </Grid>
                    </Grid>
                </div>
            </div>
        </div>
    );
}
